module.exports = __webpack_public_path__ + "img/unpin-icon.0adcce48.svg";